<template>
  <div>
    <div class="list-area" v-if="ready">
      <div v-if="noData" class="no-contents">조회 결과가 없습니다</div>
      <program-detail-slider @load-more="loadMoreProgramList" />
    </div>
  </div>
</template>

<script>
import ProgramDetailSlider from "../components/slider/ProgramDetailSlider.vue";

export default {
  data() {
    return {
      isActiveVue: true,
      ready: false,
      noData: false,
      currentPage: 1,
      programPageItem: 20,
      isLoading: false,
      hasMore: true
    };
  },

  computed: {
    listItems() {
      return this.$store.getters.programDetailList;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
  },

  watch: {
    fousedView(val) {
      if (this.isActiveVue == true && val == "default" && this.noData == true) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
  },

  components: {
    ProgramDetailSlider,
  },

  created() {
    this.$progress.$emit("on:progress");
    this.$store.commit("SET_FOCUSED_VIEW", "default");
    this.$store.commit("REMOVE_PROGRAM_DETAIL_LIST");

    this.loadMoreProgramList()
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
  methods: {
    loadMoreProgramList() {
      if (this.isLoading || !this.hasMore) {
        return
      }

      this.isLoading = true;

      this.$store
        .dispatch("FETCH_PROGRAM_DETAIL_LIST", {
          programId: this.$route.params.programId,
          pageNo: this.currentPage,
          pageItem: this.programPageItem,
        })
        .then((response) => {
          this.$progress.$emit("off:progress");

          if (!response || !response.data || response.data.count == 0) {
            if (this.currentPage === 1) {
              this.noData = true;
              this.$store.commit("SET_FOCUSED_VIEW", "gnb");
            }

            this.hasMore = false
          } else {
            // 더 가져올 데이터가 있는지 확인
            const loadedCount = this.$store.getters.programDetailList.list.length;
            const totalCount = response.data.count;
            this.hasMore = loadedCount < totalCount;

            if (this.hasMore) {
              this.currentPage++;
            }
          }

          this.ready = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$progress.$emit("off:progress");
        })
    }
  }
};
</script>

<style scoped>
.list-area {
  position: relative;
  left: 458px;
}

.no-contents {
  font-size: 32px;
  left: 320px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .list-area {
    left: 0px;
    width: 100vw;
    height: 100vh;
  }

  .no-contents {
    font-size: 32px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgba(30, 30, 30, 0.95);
  }
}
</style>